export class PriceDetails {
    static prod_bricks_rate_6 = 3;
    static prod_bricks_rate_8 = 4;
    static shift_bricks_rate_6 = 0.75;
    static shift_bricks_rate_8 = 0.75;

    static load_bricks_rate_6 = 1;
    static load_bricks_rate_8 = 5.5;

}

export const ROUND = (value: number)=> {
    try {
        return Math.round(value * 100) / 100;
    } catch (error) {
      console.error("ROUND", error);
    }
    return 0;

}

export const Months = {
    1:'Janaury',
    2:'February',
    3:'March',
    4:'April',
    5:'May',
    6:'June',
    7:'July',
    8:'August',
    9:'September',
    10:'October',
    11:'November',
    12:'December'
}

export const MonthsData = [
  {name: 'January', value:1},
  {name: 'February', value:2},
  {name: 'March', value:3},
  {name: 'April', value:4},
  {name: 'May', value:5},
  {name: 'June', value:6},
  {name: 'July', value:7},
  {name: 'August', value:8},
  {name: 'September', value:9},
  {name: 'October', value:10},
  {name: 'November', value:11},
  {name: 'December', value:12}

]



export class PaymentMode {
    payment_mode_id!:number;
    payment_mode_name!:string;
    created_date!:Date;
}

export class Validator {
    public static isEmptyObject(obj: any) {
        if (obj === null ||
            obj === undefined ||
            Array.isArray(obj) ||
            typeof obj !== 'object'
        ) {
            return true;
        }
        return Object.getOwnPropertyNames(obj).length === 0;
    };

    static isArrayValid(obj:any) {
        return Array.isArray(obj);
    }


    static isEmptyValue(obj: any) {
        if (obj === null ||
            obj === undefined ||
            obj === ''
        ){
            return true;
        }
        return false;
    }

    static isEmptyArray(obj: any) {
      if (obj === null ||
          obj === undefined ||
          obj.length === 0
      ){
          return true;
      }
      return false;
  }
}

export const searchInvoiceItem = 'Search Item'


export const VALIDATOR_REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export const  groupBy = (xs: any[], f: { (c: any): any; (arg0: any): any; }) => {
    return xs.reduce((r: { [x: string]: any[]; }, v: any, i: any, a: any, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
}

export const ReceivableAmountType = [
  {name: 'Cash in Hand', value:'cihnd'},
  {name: 'PAYTM', value:'paytm'},
  {name: 'GPAY - P', value:'gpayp'},
  {name: 'GPAY - C', value:'gpayc'},
  {name: 'Internet Amount Transfer', value:'iatfr'}
]

export const  isModifiedToday = (date: any): boolean => {
  let status = false;
  try {
    if(new Date(date).setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) {
      status = true;
    }
  } catch (error) {
    console.error("isModifiedToday", error);
  }
  return status;
}

export const isNull = (value:any):boolean =>{
  if(!value || value===null || value === undefined || value === '' || value==='null'){
    return true;
  }
  return false;
}


export const   getBase64ImageFromUrl =  async (imageUrl:any) => {
  const res = await fetch(imageUrl);
  const blob = await res.blob();

  return new Promise((resolve, reject) => {
    const reader  = new FileReader();
    reader.addEventListener("load", function () {
        resolve(reader.result);
    }, false);

    reader.onerror = () => {
      return reject(this);
    };
    reader.readAsDataURL(blob);
  })
}


export const   isUuidString = (value: string) =>{
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
}


export const printHtmlContent =($id:string)=> {
  const printContents = document.getElementById($id)?.innerHTML;
  if (printContents) {
      const popupWin = window.open('', '_blank', 'width=800,height=600');
      const styles = `
          <link href="/assets/css/style.bundle.css" rel="stylesheet" type="text/css">
          <link href="/assets/css/style.css" rel="stylesheet" type="text/css">
          <style>
              
          </style>
      `;
      popupWin?.document.open();
      popupWin?.document.write(`
          <html>
              <head>
                  <title>Print</title>
                  ${styles}
              </head>
              <body onload="window.print();window.close()">${printContents}</body>
          </html>
      `);
      popupWin?.document.close();
  }
}
